import React, { useEffect, useMemo, useRef, useState } from "react";
import api from "../api";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import * as XLSX from "xlsx";



const PRE_PRIMARY_IMPORT_ROWS = [
  { Name: "Pen Paper Assessment", Abbreviation: "PPA", Type: "MARKS", "Max Marks": 100, "Assessment Nature": "EXTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Overall Grade", Abbreviation: "OG", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Recognition of Picture", Abbreviation: "RCP", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Sentence Construction", Abbreviation: "SCN", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Fluency and Interaction", Abbreviation: "FLI", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Sorting, Matching & Ordering", Abbreviation: "SMORD", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Working Together", Abbreviation: "WTG", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Self Feeding", Abbreviation: "SFD", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Personal Development", Abbreviation: "PDEV", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Independent Work", Abbreviation: "INW", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Cleanliness and Hygiene", Abbreviation: "CLH", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Obedience", Abbreviation: "OBE", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Sense of Nature", Abbreviation: "SON", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Awareness of Surroundings", Abbreviation: "AOS", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Family and Home", Abbreviation: "FAMH", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Animals, Homes and Habitats", Abbreviation: "ANHH", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Identification Activity", Abbreviation: "IDA", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Neuro-Muscular Coordination", Abbreviation: "NMC", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Rhymes, Tunes and Rhythm", Abbreviation: "RTRH", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Singing in Tune", Abbreviation: "SINT", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Hand-Muscle Integration", Abbreviation: "HMIN", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
  { Name: "Handwork", Abbreviation: "HWK", Type: "GRADE", "Max Marks": "", "Assessment Nature": "INTERNAL", "Academic Category": "Scholastic", Practical: "No", Active: "Yes" },
];

const normalizeImportHeader = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

const importBoolean = (value, fallback = false) => {
  if (value === undefined || value === null || value === "") return fallback;
  if (typeof value === "boolean") return value;
  const normalized = String(value).trim().toLowerCase();
  return ["yes", "y", "true", "1", "active", "internal"].includes(normalized);
};

const downloadRowsAsExcel = (rows, filename, sheetName = "Assessment Components") => {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet["!cols"] = [
    { wch: 38 },
    { wch: 16 },
    { wch: 12 },
    { wch: 12 },
    { wch: 20 },
    { wch: 20 },
    { wch: 12 },
    { wch: 10 },
  ];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
  XLSX.writeFile(workbook, filename);
};

const defaultFormData = {
  id: null,
  name: "",
  abbreviation: "",
  max_marks: "",
  component_type: "MARKS",
  is_internal: false,
  scholastic_type: "Scholastic",
  is_practical: false,
  is_active: true,
};

const AssessmentComponentManagement = () => {
  const [components, setComponents] = useState([]);
  const [formData, setFormData] = useState(defaultFormData);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("ALL");
  const [natureFilter, setNatureFilter] = useState("ALL");
  const [academicFilter, setAcademicFilter] = useState("ALL");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const importInputRef = useRef(null);
  const [importing, setImporting] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);

  const filteredComponents = useMemo(() => {
    const query = search.trim().toLowerCase();

    return components.filter((component) => {
      const matchesSearch =
        !query ||
        String(component.name || "").toLowerCase().includes(query) ||
        String(component.abbreviation || "").toLowerCase().includes(query);
      const matchesType =
        typeFilter === "ALL" || component.component_type === typeFilter;
      const matchesNature =
        natureFilter === "ALL" ||
        (natureFilter === "INTERNAL" && Boolean(component.is_internal)) ||
        (natureFilter === "EXTERNAL" && !component.is_internal);
      const matchesAcademic =
        academicFilter === "ALL" ||
        (component.scholastic_type || "Scholastic") === academicFilter;
      const matchesStatus =
        statusFilter === "ALL" ||
        (statusFilter === "ACTIVE" && Boolean(component.is_active)) ||
        (statusFilter === "INACTIVE" && !component.is_active);

      return (
        matchesSearch &&
        matchesType &&
        matchesNature &&
        matchesAcademic &&
        matchesStatus
      );
    });
  }, [components, search, typeFilter, natureFilter, academicFilter, statusFilter]);

  useEffect(() => {
    fetchComponents();
  }, []);

  const fetchComponents = async () => {
    try {
      const res = await api.get("/assessment-components");
      setComponents(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to fetch components:", err);
      Swal.fire("Error", "Failed to fetch components", "error");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let val = type === "checkbox" ? checked : value;

    if (name === "is_internal" && type !== "checkbox") {
      val = value === "INTERNAL";
    }

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: val,
      };

      // Grade based components do not need max marks
      if (name === "component_type" && value === "GRADE") {
        updated.max_marks = 0;
      }

      return updated;
    });
  };

  const handleEdit = (comp) => {
    setFormData({
      id: comp.id,
      name: comp.name || "",
      abbreviation: comp.abbreviation || "",
      max_marks:
        comp.component_type === "GRADE"
          ? 0
          : comp.max_marks !== null && comp.max_marks !== undefined
          ? comp.max_marks
          : "",
      component_type: comp.component_type || "MARKS",
      is_internal: Boolean(comp.is_internal),
      scholastic_type: comp.scholastic_type || "Scholastic",
      is_practical: Boolean(comp.is_practical),
      is_active:
        comp.is_active === undefined || comp.is_active === null
          ? true
          : Boolean(comp.is_active),
    });

    setIsEditing(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleReset = () => {
    setFormData(defaultFormData);
    setIsEditing(false);
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      Swal.fire("Warning", "Component name is required", "warning");
      return false;
    }

    if (!formData.abbreviation.trim()) {
      Swal.fire("Warning", "Abbreviation is required", "warning");
      return false;
    }

    if (!["MARKS", "GRADE"].includes(formData.component_type)) {
      Swal.fire("Warning", "Please select a valid component type", "warning");
      return false;
    }

    if (!["Scholastic", "Co-Scholastic"].includes(formData.scholastic_type)) {
      Swal.fire("Warning", "Please select Scholastic or Co-Scholastic", "warning");
      return false;
    }

    if (formData.component_type === "MARKS") {
      if (
        formData.max_marks === "" ||
        formData.max_marks === null ||
        formData.max_marks === undefined
      ) {
        Swal.fire("Warning", "Max marks are required for marks-based component", "warning");
        return false;
      }

      const maxMarks = Number(formData.max_marks);

      if (Number.isNaN(maxMarks) || maxMarks < 0) {
        Swal.fire("Warning", "Max marks must be a valid number", "warning");
        return false;
      }
    }

    return true;
  };

  const buildPayload = () => {
    const isGrade = formData.component_type === "GRADE";

    return {
      name: formData.name.trim(),
      abbreviation: formData.abbreviation.trim(),
      component_type: formData.component_type,
      max_marks: isGrade ? 0 : Number(formData.max_marks || 0),
      is_internal: Boolean(formData.is_internal),
      scholastic_type: formData.scholastic_type,
      is_practical: Boolean(formData.is_practical),
      is_active: Boolean(formData.is_active),
    };
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);

      const payload = buildPayload();

      if (isEditing) {
        await api.put(`/assessment-components/${formData.id}`, payload);
        Swal.fire("Success", "Component updated successfully", "success");
      } else {
        await api.post("/assessment-components", payload);
        Swal.fire("Success", "Component created successfully", "success");
      }

      handleReset();
      fetchComponents();
    } catch (err) {
      console.error("Failed to save component:", err);
      Swal.fire(
        "Error",
        err?.response?.data?.message || "Failed to save component",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const buildExportRows = (sourceRows) =>
    sourceRows.map((component) => ({
      Name: component.name || "",
      Abbreviation: component.abbreviation || "",
      Type: component.component_type || "MARKS",
      "Max Marks": component.component_type === "GRADE" ? "" : component.max_marks ?? 0,
      "Assessment Nature": component.is_internal ? "INTERNAL" : "EXTERNAL",
      "Academic Category": component.scholastic_type || "Scholastic",
      Practical: component.is_practical ? "Yes" : "No",
      Active: component.is_active ? "Yes" : "No",
    }));

  const handleExport = () => {
    const rows = buildExportRows(filteredComponents);
    if (!rows.length) {
      Swal.fire("Nothing to export", "No components match the current filters.", "info");
      return;
    }

    downloadRowsAsExcel(
      rows,
      `assessment_components_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  const handleDownloadPrePrimaryImport = () => {
    downloadRowsAsExcel(
      PRE_PRIMARY_IMPORT_ROWS,
      "pre_primary_assessment_components_import.xlsx",
      "Pre-Primary Components"
    );
  };

  const parseImportRows = (rawRows) => {
    return rawRows
      .map((row, index) => {
        const cells = Object.entries(row || {}).reduce((acc, [key, value]) => {
          acc[normalizeImportHeader(key)] = value;
          return acc;
        }, {});

        const read = (...keys) => {
          for (const key of keys) {
            const normalized = normalizeImportHeader(key);
            if (cells[normalized] !== undefined) return cells[normalized];
          }
          return "";
        };

        const name = String(read("Name", "Component Name", "name") || "").trim();
        const abbreviation = String(read("Abbreviation", "Abbr", "abbreviation") || "").trim();
        if (!name && !abbreviation) return null;

        const rawType = String(read("Type", "Component Type", "component_type") || "MARKS")
          .trim()
          .toUpperCase();
        const componentType = rawType === "GRADE" ? "GRADE" : rawType === "MARKS" ? "MARKS" : rawType;

        const nature = String(read("Assessment Nature", "Nature", "is_internal") || "EXTERNAL")
          .trim()
          .toUpperCase();
        const academicRaw = String(read("Academic Category", "Scholastic Type", "scholastic_type") || "Scholastic")
          .trim()
          .toLowerCase();

        return {
          row_number: index + 2,
          name,
          abbreviation,
          component_type: componentType,
          max_marks: componentType === "GRADE" ? 0 : read("Max Marks", "max_marks"),
          is_internal: nature === "INTERNAL" || importBoolean(read("is_internal"), false),
          scholastic_type: academicRaw.includes("co") ? "Co-Scholastic" : "Scholastic",
          is_practical: importBoolean(read("Practical", "is_practical"), false),
          is_active: importBoolean(read("Active", "is_active"), true),
        };
      })
      .filter(Boolean);
  };

  const processImportFile = async (file) => {
    if (!file) return;

    const fileName = String(file.name || "").toLowerCase();
    const allowedExtensions = [".xlsx", ".xls", ".csv"];
    if (!allowedExtensions.some((extension) => fileName.endsWith(extension))) {
      Swal.fire(
        "Unsupported file",
        "Please select an Excel (.xlsx/.xls) or CSV file.",
        "warning"
      );
      return;
    }

    try {
      setImporting(true);
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawRows = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
      const componentsToImport = parseImportRows(rawRows);

      if (!componentsToImport.length) {
        Swal.fire("No rows found", "The selected file does not contain importable component rows.", "warning");
        return;
      }

      const confirm = await Swal.fire({
        title: `Import ${componentsToImport.length} rows?`,
        html: "<b>Safe import:</b> existing component names or abbreviations will be skipped. Only missing components will be added.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Import missing only",
        cancelButtonText: "Cancel",
      });

      if (!confirm.isConfirmed) return;

      const response = await api.post("/assessment-components/bulk-import", {
        components: componentsToImport,
      });

      const result = response.data || {};
      const skippedPreview = (result.skipped || [])
        .slice(0, 5)
        .map((item) => `<li>${item.name || item.abbreviation}: ${item.reason}</li>`)
        .join("");
      const invalidPreview = (result.invalid || [])
        .slice(0, 5)
        .map((item) => `<li>Row ${item.row_number}: ${item.reason}</li>`)
        .join("");

      await Swal.fire({
        title: "Import complete",
        icon: result.invalid_count ? "warning" : "success",
        html: `
          <div class="text-start">
            <p class="mb-1"><b>Added:</b> ${result.added_count || 0}</p>
            <p class="mb-1"><b>Skipped existing:</b> ${result.skipped_count || 0}</p>
            <p class="mb-2"><b>Invalid:</b> ${result.invalid_count || 0}</p>
            ${skippedPreview ? `<div><b>Skipped sample:</b><ul>${skippedPreview}</ul></div>` : ""}
            ${invalidPreview ? `<div><b>Invalid sample:</b><ul>${invalidPreview}</ul></div>` : ""}
          </div>
        `,
      });

      await fetchComponents();
    } catch (err) {
      console.error("Failed to import assessment components:", err);
      Swal.fire(
        "Import failed",
        err?.response?.data?.message || err?.message || "Failed to import components.",
        "error"
      );
    } finally {
      setImporting(false);
      setIsDragActive(false);
    }
  };

  const handleImportFile = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    await processImportFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!importing) setIsDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragActive(false);
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragActive(false);
    if (importing) return;

    const file = event.dataTransfer?.files?.[0];
    await processImportFile(file);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Deactivate this component?",
      text: "This will hide the component from active list.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, deactivate it",
      cancelButtonText: "Cancel",
    });

    if (confirm.isConfirmed) {
      try {
        await api.delete(`/assessment-components/${id}`);
        Swal.fire("Done", "Component deactivated successfully", "success");
        fetchComponents();
      } catch (err) {
        console.error("Failed to deactivate component:", err);
        Swal.fire(
          "Error",
          err?.response?.data?.message || "Failed to deactivate component",
          "error"
        );
      }
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
          <h2 className="mb-1">🧮 Assessment Components</h2>
          <div className="text-muted small">
            Import is duplicate-safe: existing names or abbreviations are skipped; only missing components are added.
          </div>
        </div>

        <div className="d-flex flex-wrap gap-2">
          <button
            type="button"
            className="btn btn-outline-success"
            onClick={handleExport}
          >
            📤 Export Excel ({filteredComponents.length})
          </button>

          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={handleDownloadPrePrimaryImport}
          >
            ⬇️ Pre-Primary Import File
          </button>

          <button
            type="button"
            className="btn btn-primary"
            onClick={() => importInputRef.current?.click()}
            disabled={importing}
          >
            {importing ? "Importing..." : "📥 Import Excel / CSV"}
          </button>

          <input
            ref={importInputRef}
            type="file"
            className="d-none"
            accept=".xlsx,.xls,.csv"
            onChange={handleImportFile}
          />
        </div>
      </div>

      <div
        className="mt-3 rounded-3 text-center"
        onDragOver={handleDragOver}
        onDragEnter={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => !importing && importInputRef.current?.click()}
        onKeyDown={(event) => {
          if (!importing && (event.key === "Enter" || event.key === " ")) {
            event.preventDefault();
            importInputRef.current?.click();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Drag and drop assessment components import file or click to browse"
        style={{
          border: `2px dashed ${isDragActive ? "#0d6efd" : "#b8c2cc"}`,
          backgroundColor: isDragActive ? "#eef6ff" : "#f8f9fa",
          padding: "18px 16px",
          cursor: importing ? "not-allowed" : "pointer",
          transition: "all 0.18s ease",
          opacity: importing ? 0.7 : 1,
        }}
      >
        <div className="fw-semibold">
          {importing
            ? "Importing assessment components..."
            : isDragActive
              ? "Drop the file here to import"
              : "📂 Drag & drop Excel / CSV here"}
        </div>
        <div className="text-muted small mt-1">
          Or click this area to browse. Existing Name or Abbreviation will be skipped; only missing components are added.
        </div>
        <div className="text-muted small mt-1">Supported: .xlsx, .xls, .csv</div>
      </div>

      <div className="card mt-4 mb-4">
        <div className="card-body">
          <h5 className="card-title">
            {isEditing ? "✏️ Edit Component" : "➕ Add Component"}
          </h5>

          <div className="row">
            <div className="col-md-3 mb-3">
              <label className="form-label">Name *</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g. Periodic Test / Listening Skills"
                className="form-control"
              />
            </div>

            <div className="col-md-2 mb-3">
              <label className="form-label">Abbreviation *</label>
              <input
                name="abbreviation"
                value={formData.abbreviation}
                onChange={handleChange}
                placeholder="e.g. PT / LS"
                className="form-control"
              />
            </div>

            <div className="col-md-2 mb-3">
              <label className="form-label">Type *</label>
              <select
                name="component_type"
                value={formData.component_type}
                onChange={handleChange}
                className="form-select"
              >
                <option value="MARKS">Marks</option>
                <option value="GRADE">Grade</option>
              </select>
            </div>

            <div className="col-md-2 mb-3">
              <label className="form-label">
                Max Marks {formData.component_type === "MARKS" ? "*" : ""}
              </label>
              <input
                type="number"
                name="max_marks"
                value={formData.max_marks}
                onChange={handleChange}
                placeholder="e.g. 20"
                className="form-control"
                disabled={formData.component_type === "GRADE"}
                min="0"
              />
              {formData.component_type === "GRADE" && (
                <small className="text-muted">Not required for grade-based skills</small>
              )}
            </div>

            <div className="col-md-2 mb-3">
              <label className="form-label">Assessment Nature *</label>
              <select
                name="is_internal"
                value={formData.is_internal ? "INTERNAL" : "EXTERNAL"}
                onChange={handleChange}
                className="form-select"
              >
                <option value="INTERNAL">Internal</option>
                <option value="EXTERNAL">External</option>
              </select>
            </div>

            <div className="col-md-2 mb-3">
              <label className="form-label">Academic Category *</label>
              <select
                name="scholastic_type"
                value={formData.scholastic_type}
                onChange={handleChange}
                className="form-select"
              >
                <option value="Scholastic">Scholastic</option>
                <option value="Co-Scholastic">Co-Scholastic</option>
              </select>
            </div>

            <div className="col-md-1 mb-3 form-check mt-4">
              <input
                type="checkbox"
                name="is_practical"
                checked={formData.is_practical}
                onChange={handleChange}
                className="form-check-input"
                id="practicalCheck"
              />
              <label htmlFor="practicalCheck" className="form-check-label">
                Practical
              </label>
            </div>

            <div className="col-md-1 mb-3 form-check mt-4">
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
                className="form-check-input"
                id="activeCheck"
              />
              <label htmlFor="activeCheck" className="form-check-label">
                Active
              </label>
            </div>

            <div className="col-md-12 d-flex gap-2 mt-2">
              <button
                className="btn btn-success"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Saving..." : isEditing ? "Update" : "Create"}
              </button>

              {isEditing && (
                <button
                  className="btn btn-secondary"
                  onClick={handleReset}
                  disabled={loading}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <h5 className="card-title mb-0">
              Component List ({filteredComponents.length}/{components.length})
            </h5>

            <div className="d-flex flex-wrap gap-2">
              <input
                type="search"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                className="form-control"
                style={{ minWidth: 240 }}
                placeholder="Search name or abbreviation..."
                aria-label="Search assessment components"
              />

              <select
                value={typeFilter}
                onChange={(event) => setTypeFilter(event.target.value)}
                className="form-select"
                aria-label="Filter by component type"
              >
                <option value="ALL">All Types</option>
                <option value="MARKS">Marks</option>
                <option value="GRADE">Grade</option>
              </select>

              <select
                value={natureFilter}
                onChange={(event) => setNatureFilter(event.target.value)}
                className="form-select"
                aria-label="Filter by assessment nature"
              >
                <option value="ALL">Internal + External</option>
                <option value="INTERNAL">Internal</option>
                <option value="EXTERNAL">External</option>
              </select>

              <select
                value={academicFilter}
                onChange={(event) => setAcademicFilter(event.target.value)}
                className="form-select"
                aria-label="Filter by academic category"
              >
                <option value="ALL">Scholastic + Co-Scholastic</option>
                <option value="Scholastic">Scholastic</option>
                <option value="Co-Scholastic">Co-Scholastic</option>
              </select>

              <select
                value={statusFilter}
                onChange={(event) => setStatusFilter(event.target.value)}
                className="form-select"
                aria-label="Filter by component status"
              >
                <option value="ALL">All Statuses</option>
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
              </select>

              {(search ||
                typeFilter !== "ALL" ||
                natureFilter !== "ALL" ||
                academicFilter !== "ALL" ||
                statusFilter !== "ALL") && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    setSearch("");
                    setTypeFilter("ALL");
                    setNatureFilter("ALL");
                    setAcademicFilter("ALL");
                    setStatusFilter("ALL");
                  }}
                >
                  Clear
                </button>
              )}
            </div>
          </div>

          {filteredComponents.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-striped table-bordered align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Abbr.</th>
                    <th>Type</th>
                    <th>Max Marks</th>
                    <th>Assessment Nature</th>
                    <th>Academic Category</th>
                    <th>Practical</th>
                    <th>Active</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredComponents.map((comp, index) => (
                    <tr key={comp.id}>
                      <td>{index + 1}</td>
                      <td>{comp.name}</td>
                      <td>{comp.abbreviation}</td>
                      <td>
                        <span
                          className={`badge ${
                            comp.component_type === "GRADE"
                              ? "bg-info text-dark"
                              : "bg-primary"
                          }`}
                        >
                          {comp.component_type === "GRADE" ? "Grade" : "Marks"}
                        </span>
                      </td>
                      <td>
                        {comp.component_type === "GRADE"
                          ? "-"
                          : comp.max_marks ?? 0}
                      </td>
                      <td>
                        <span className={`badge ${comp.is_internal ? "bg-success" : "bg-secondary"}`}>
                          {comp.is_internal ? "Internal" : "External"}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            (comp.scholastic_type || "Scholastic") === "Co-Scholastic"
                              ? "bg-warning text-dark"
                              : "bg-dark"
                          }`}
                        >
                          {comp.scholastic_type || "Scholastic"}
                        </span>
                      </td>
                      <td>{comp.is_practical ? "Yes" : "No"}</td>
                      <td>{comp.is_active ? "Yes" : "No"}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-warning me-2"
                          onClick={() => handleEdit(comp)}
                        >
                          Edit
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(comp.id)}
                        >
                          Deactivate
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-muted mb-0">
              {components.length
                ? "No components match the selected filters."
                : "No components found."}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssessmentComponentManagement;
